import type { Comment } from '@/types/comment';

/** Окно «4 часа после создания» для редактирования своего комментария. */
export const OWN_COMMENT_EDIT_WINDOW_MS = 4 * 60 * 60 * 1000;

/**
 * Автор может редактировать свой комментарий только в течение 4 часов после создания.
 */
export function canAuthorEditOwnComment(
  comment: Pick<Comment, 'createdAt'>,
  options?: { nowMs?: number },
): boolean {
  const createdAtMs = new Date(comment.createdAt).getTime();
  if (!Number.isFinite(createdAtMs)) {
    return false;
  }

  const nowMs = options?.nowMs ?? Date.now();
  return nowMs - createdAtMs <= OWN_COMMENT_EDIT_WINDOW_MS;
}
